import { AbstractModel } from './AbstractModel'

export class RallyRoundHeaderImage extends AbstractModel {
    public id = 0
    public image: string|null = null
}
